import { Component, Input, Output, EventEmitter } from '@angular/core'
import { SdkAndroidApprovalFlowService } from '../../../features/integrations/services/sdk-android-approval-flow-form.service'

@Component({
    selector: 'app-barra-progresso',
    templateUrl: './barra-progresso.component.html',
    styleUrls: ['./barra-progresso.component.scss'],
})
export class BarraProgressoComponent {
    @Input() porcentagemAtual: number = 0

    constructor(
        private sdkAndroidApprovalFlowService: SdkAndroidApprovalFlowService,
        // private connectApprovalFlowService: ConnectApprovalFlowService,
        // private autotefApprovalFlowService: AutotefApprovalFlowService
    ) {}

    @Output() porcentagemUpload1 = new EventEmitter()
    @Output() porcentagemUpload2 = new EventEmitter()
    @Output() porcentagemUpload3 = new EventEmitter()

    ngOnInit() {
        this.sdkAndroidApprovalFlowService.percentageUpload1$.subscribe((porcentagem: any) => {
            this.porcentagemAtual = porcentagem
        })
        // this.connectApprovalFlowService.percentageUpload1$.subscribe((porcentagem: any) => {
        //     this.porcentagemAtual = porcentagem
        // })
        // this.autotefApprovalFlowService.percentageUpload1$.subscribe((porcentagem:any) => {
        //     this.porcentagemAtual = porcentagem
        // })
    }
}
